export const POSITIONS_SET_ACCOUNTS = 'positions/set-accounts';
export const POSITIONS_SET_SYMBOLS = 'positions/set-symbols';
export const POSITIONS_UPDATE_ACCOUNT = 'positions/update-account';
export const POSITIONS_UPDATE_SYMBOL = 'positions/update-symbol';
export const POSITIONS_COPY_STATE = 'positions/copy-state';